import { useSidebar } from "./index";
import { cn } from "../../lib/utils";

const SidebarFilterContent = ({ onReset, title, children }) => {
	const { isFilterOpen, hasFilterApplied } = useSidebar();

	if (!isFilterOpen) return null;

	return (
		<div className="fade_in grid gap-3">
			<div className="flex justify-between items-center">
				{title && <div className="font-semibold">{title}</div>}
				<button
					type="button"
					disabled={!hasFilterApplied}
					className={cn(
						"flex justify-center gap-2 items-center !text-interactive-100 text-12 font-bold py-[6px]",
						hasFilterApplied ? "hover:opacity-70 cursor-pointer" : "opacity-30 pointer-events-none"
					)}
					onClick={() => hasFilterApplied && onReset?.()}
				>
					<span className="icon_16 default cross icon_mask !bg-interactive-100 flex-none"></span>
					Resetta
				</button>
			</div>
			<div className="flex gap-[10px] flex-wrap">{children}</div>
		</div>
	);
};

SidebarFilterContent.displayName = "SidebarFilterContent";

export default SidebarFilterContent;
